/* eslint-disable import/first */
import React from 'react';
import { Button, TextField } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import { AiOutlineCheck } from '@react-icons/all-files/ai/AiOutlineCheck';
const { selectDesktop } = Slices.appSlice;
// import Badge from '../../components/Icons/Badge';
import css from './index.module.scss';
import ClassNames from 'classnames';
function ChangeAddress({
  markers,
  changeMap,
  setBldNu,
  bldNu,
  buildingPlaceholder,
  setFlatNu,
  flatNu,
  flatNoPlaceholder,
  setHowTo,
  howTo,
  howToReachpl,
  allTags,
  setTag,
  tag,
  handleForm,
  status,
  buttonText,
}) {
  //Map key added  - used personal
  // const intl = useIntl();
  // eslint:fix intl is declared but its value is never read
  const isDesktop = useSelector(selectDesktop);
  const [bldgError, setBldgError] = React.useState('');
  const [flatError, setflatError] = React.useState('');
  const intl = useIntl();
  const checkLengthBuidling = (newBuildingName) => {
    if (newBuildingName?.length > 50) {
      setBldgError(
        intl.formatMessage({
          id: 'bldg_error',
          defaultMessage: 'Max length of Buidling field is 50',
        })
      );
    } else {
      if (newBuildingName?.length === 0) {
        setBldgError(
          intl.formatMessage({ id: 'required_field', defaultMessage: 'Required Field' })
        );
      } else {
        setBldgError('');
      }
    }
  };
  const checkLengthFlat = (newFlatNumber) => {
    if (newFlatNumber?.length > 12) {
      setflatError(
        intl.formatMessage({ id: 'flat_error', defaultMessage: 'Max length of Flat field is 12' })
      );
    } else {
      if (newFlatNumber?.length === 0) {
        setflatError(
          intl.formatMessage({ id: 'required_field', defaultMessage: 'Required Field' })
        );
      } else {
        setflatError('');
      }
    }
  };
  return (
    <div className={css.addressDrawer}>
      {/* <Badge className={css.badge} /> */}
      <div className={css.addForm}>
        <div className={css.headingDrawer}>
          <h3>
            <FormattedMessage
              id="addaddress_completeaddress"
              defaultMessage="Complete your address"
            />
          </h3>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => changeMap('complete')}
            // className={css.change}
            className={ClassNames(css.change, css.changeButton)}
          >
            <FormattedMessage id="feedback_change" defaultMessage="CHANGE" />
          </Button>
        </div>
        <div className={css.addressDetail}>{markers[0] ? markers[0].address : ''}</div>
        <div className={css.desktopForm}>
          {/* <div className={css.formInput}>
            <TextField
              className={ClassNames(css.howToField, css.removeBord)}
              value={markers[0] ? markers[0].address : ''}
              disabled
              type="text"
            />
            <div>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => changeMap('complete')}
                // className={css.change}
                className={ClassNames(css.change)}
              >
                <FormattedMessage id="feedback_change" defaultMessage="CHANGE" />
              </Button>
            </div>
          </div> */}
          <div className={css.formInput}>
            <div className={css.subInp}>
              <input
                autoFocus
                maxLength="50"
                inputProps={{
                  maxLength: 50,
                }}
                name="buidling"
                autoComplete="off"
                onChange={(e) => {
                  e.preventDefault();
                  setBldNu(e.target.value);
                  checkLengthBuidling(e.target.value);
                }}
                value={bldNu}
                placeholder={buildingPlaceholder}
                className={ClassNames(css.inputField, { [css.errorInput]: bldgError !== '' })}
              />
              {bldgError !== '' ? <span className={css.flatError}>{bldgError}</span> : ''}
            </div>
            <div className={css.subInp}>
              <input
                maxLength="12"
                name="flat"
                autoComplete="off"
                onChange={(e) => {
                  e.preventDefault();
                  setFlatNu(e.target.value);
                  checkLengthFlat(e.target.value);
                }}
                value={flatNu}
                placeholder={flatNoPlaceholder}
                className={ClassNames(css.inputField, { [css.errorInput]: flatError !== '' })}
              />
              {flatError !== '' ? <span className={css.flatError}>{flatError}</span> : ''}
            </div>
          </div>

          <div className={css.formInput}>
            <input
              maxLength="200"
              name="how"
              autoComplete="off"
              onChange={(e) => {
                setHowTo(e.target.value);
              }}
              value={howTo || ''}
              placeholder={howToReachpl}
              className={css.howToField}
            />
          </div>
          <div className={css.addressTags}>
            <div>
              <div className={css.tagHeading}>
                <FormattedMessage id="addaddress_location" defaultMessage="Tag location" />:
              </div>
              <div className={css.tags}>
                {allTags.map((value, i) => {
                  return (
                    <Button
                      key={i}
                      onClick={() => setTag(value.id)}
                      className={value.id === tag && css.active}
                      // startIcon={value.id === tag && <AiOutlineCheck size=".7em" color="#fff" />}
                    >
                      {value.val}
                    </Button>
                  );
                })}
              </div>
            </div>
            {isDesktop && (
              <Button
                variant="contained"
                color="primary"
                className={css.confirm}
                onClick={handleForm}
                disabled={
                  status === 'loading' ||
                  status === 'initial' ||
                  !bldNu ||
                  bldgError !== '' ||
                  flatError !== '' ||
                  !flatNu ||
                  bldNu.trim().length === 0 ||
                  flatNu.trim().length === 0
                }
              >
                <span className={css.addAddressText}>
                  <FormattedMessage id="gotit" defaultMessage="Add address" />
                </span>
              </Button>
            )}
          </div>
          {!isDesktop && (
            <Button
              variant="contained"
              color="primary"
              className={css.confirm}
              onClick={handleForm}
              disabled={
                status === 'loading' ||
                status === 'initial' ||
                !bldNu ||
                bldgError !== '' ||
                flatError !== '' ||
                !flatNu ||
                bldNu.trim().length === 0 ||
                flatNu.trim().length === 0
              }
            >
              <span className={css.addAddressText}>
                <FormattedMessage id={buttonText} defaultMessage="Add address" />
              </span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChangeAddress;
